import { ApiOptions, Patient, Site, UserId } from '@csp/csp-common-model';
import { UserIncludeFieldType } from '@csp/dmdp-api-user-dto';
import { CachedUserQueryService } from '@csp/csp-common-user-query';
import { PatientFactory } from '@csp/csp-common-patient-mapper';
import { StudyConfig } from '@csp/csp-common-config';

const getPatientsByUserIds = async (
  userIds: UserId[],
  fields: UserIncludeFieldType[],
  studyConfig?: StudyConfig,
  sites: Site[] = [],
  options?: ApiOptions,
): Promise<Patient[]> => {
  const cachedUsers = await CachedUserQueryService.byUserIds(userIds, fields, options);
  return cachedUsers.map(user => PatientFactory.from({ userV1: user.userV1, studyConfig, sites }));
};

export const CachedPatientQueryService = {
  getPatientsByUserIds,
};
